import PropTypes from 'prop-types';
import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import EditNoteIcon from '@mui/icons-material/EditNote';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';

import SessionNoteForm from './SessionNoteForm';
import Button from "@mui/material/Button";

const EditNoteButton = props => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const {iconOnly, textOnly, session} = props;
  const onClose = () => {
    setDialogIsOpen(false);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('note_editor', false);
    if (props.afterClose) props.afterClose();
    setSearchParams(newSearchParams);
  };
  const childProps = {
    onClick: e => {
      if (props.stopPropagation) e.stopPropagation();
      setDialogIsOpen(true);
    },
    disabled: props.disabled || false,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly || textOnly ? null : <EditNoteIcon/>,
    fullWidth: props.fullWidth || null,
    onSubmitSuccess: () => {
      onClose();
    },
    size: props.size
  };
  const label = session.is_completed ? 'Addendum Note' : 'Edit Note';
  return (
    <>
      <Dialog
        open={dialogIsOpen}
        fullWidth={true}
        maxWidth='lg'
        onClose={onClose}
      >
        <Grid container spacing={2} padding={2}>
          <Grid item xs={12} md={12} style={{paddingBottom: '0.25em'}}>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
              <Typography variant='h2'>{label}</Typography>
              <IconButton onClick={onClose}>
                <CloseIcon/>
              </IconButton>
            </Stack>
            <Divider style={{marginBottom: '1.5rem'}}/>
          </Grid>
        </Grid>
        <SessionNoteForm
          session={session}
          onSubmitSuccess={childProps.onSubmitSuccess}
        />
      </Dialog>
      {iconOnly
      ? <Tooltip title={label}>
        <IconButton {...childProps}>
          <EditNoteIcon/>
        </IconButton>
      </Tooltip>
      : <Button {...childProps}>
          {label}
        </Button>
      }
    </>
  );
};

EditNoteButton.defaultProps = {
  fullWidth: false,
  iconOnly: false,
  textOnly: false,
  stopPropagation: false,
};

EditNoteButton.propTypes = {
  session: PropTypes.object.isRequired,
  fullWidth: PropTypes.bool,
  stopPropagation: PropTypes.bool,
};

export default EditNoteButton;
